<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Instructor Module Roles</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="selected_module" :items="module_list" item-text="name"
              item-value="id" label="Module" outlined rounded persistent-hint hint="Please Select Module"
              @change="getRoles()"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" v-if="roles_list!=''">
            <v-autocomplete dense required v-model="role" :items="roles_list" item-text="name" item-value="id"
              label="Roles" outlined rounded persistent-hint hint="Please Select Role"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" v-if="role && selected_module">
            <v-btn @click="fetch()" :loading="loader" color="info">fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="user_role!='' ">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="user_role" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>User Roles</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      // extraBreadcrumbItems: [
      

      // ],
      // breadcrumbClass: "breadcrumb-style1",

      color: "",
      search: "",
      snackbar: false,
      overlay: false,
      headers:[
      { text: "User", value: "user" },
      { text: "Name", value: "name" },
      { text: "Contact No", value: "mobile_no" },
      ],
      instructor_list:[],employee:"",module_list:[],selected_module:"",user_role:[],roles_list:[],role:"",
  }),
   methods: {
     async getRoles() {
     this.loader=true
     const formData = {
                    selected_module: this.selected_module,
                };
      try {
          const res = await axios.post("/RoleManagement/getRolesForModule",formData);
          if (res.data.flag == "YES") {
             this.roles_list=res.data.roles_list
          }else if(res.data.flag == "No"){
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
          this.loader = false;
      }
     
    },
     async fetch() {
     this.loader=true
     this.user_role=[]
     const formData = {
                    selected_module: this.selected_module,
                    role: this.role,
                };
      try {
          const res = await axios.post("/RoleManagement/getInstructorModuleRolesDetails",formData);
          if (res.data.flag == "YES") {
             this.user_role=res.data.user_role
          }else if(res.data.flag == "No"){
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
          this.loader = false;
      }
     
    },
    async onLoad() {
      try {
          const res = await axios.post("/RoleManagement/getInstructorModuleRoles");
          if (res.data.flag == "YES") {
            this.instructor_list=res.data.instructor_list
            this.module_list=res.data.module_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>